'use client';
import { createContext, useContext } from 'react';

const StoreConfigContext = createContext({
    discountForAll:  0,
    prepaidDiscount: 0,
    replacementAllow: 7,
    allowCOD: true,
    coupons: [],
});

export const StoreConfigProvider = ({ config, children }) => (
    <StoreConfigContext.Provider value={config}>
        {children}
    </StoreConfigContext.Provider>
);

export const useStoreConfig = () => useContext(StoreConfigContext);
